import { SelectContentEvent } from '@moonpig/web-core-analytics'
import {
  AccordionSectionActions,
  AccordionSectionTrackingMap,
  AccordionSections,
} from './AccordionSections/types'

export const ProductAccordionSectionClickGAEvent = (
  accordionSectionValue: AccordionSections,
  accordionSectionAction: AccordionSectionActions,
  productId: string,
): SelectContentEvent => {
  const accordionSectionName =
    AccordionSectionTrackingMap[accordionSectionValue]

  return {
    event: 'select_content',
    content_data: {
      content_type: `product details | ${productId} | accordion | ${accordionSectionName.toLocaleLowerCase()} | ${accordionSectionAction}`,
    },
    event_data: {
      category: 'product details',
      action: 'view item',
      label: `product details | ${productId} | accordion | ${accordionSectionName.toLocaleLowerCase()} | ${accordionSectionAction}`,
      non_interaction: true,
      value: undefined,
    },
    error_data: undefined,
    ecommerce: undefined,
  }
}
